module.exports = __webpack_public_path__ + "media/images/swifticons/hands-clapping-e53b2645400015c0b12498cc8bdcc4e9.svg";